import { render, staticRenderFns } from "./business.vue?vue&type=template&id=37c4e083&scoped=true"
import script from "./business.vue?vue&type=script&lang=js"
export * from "./business.vue?vue&type=script&lang=js"
import style0 from "./business.vue?vue&type=style&index=0&id=37c4e083&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c4e083",
  null
  
)

export default component.exports